import React from 'react';

import { ClassroomToolbar, ClassroomList } from 'views/Classroom/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ClassroomToolbar />
      <div className={classes.content}>
        <ClassroomList />
      </div>
    </div>
  );
};
